// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__r6v0f","notes":"Notes_notes__2Suq9","note":"Notes_note__s2Aob","markdown":"Notes_markdown__3Baof"};